var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "07") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6,50a15,15,0,0,0-21.21,0l-.1.1L50,45.71l.1-.1A15,15,0,0,0,50,24.4l-6.2-6.2a15,15,0,0,0-21.21,0l-4.44,4.44a15,15,0,0,0,0,21.21L24.4,50a15,15,0,0,0,21.21,0l.1-.1L50,54.29l-.1.1A15,15,0,0,0,50,75.6l6.2,6.2a15,15,0,0,0,21.21,0l4.44-4.44a15,15,0,0,0,0-21.21ZM41.37,45.81a9,9,0,0,1-12.73,0l-6.2-6.2a9,9,0,0,1,0-12.73l4.44-4.44a9,9,0,0,1,12.73,0l6.2,6.2a9,9,0,0,1,0,12.73l-.1.1L36.22,32A3,3,0,0,0,32,36.22l9.49,9.49Zm36.2,27.32-4.44,4.44a9,9,0,0,1-12.73,0l-6.2-6.2a9,9,0,0,1,0-12.73l.1-.1L63.78,68A3,3,0,0,0,68,63.78l-9.49-9.49.1-.1a9,9,0,0,1,12.73,0l6.2,6.2A9,9,0,0,1,77.56,73.12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounLink);
export default __webpack_public_path__ + "static/media/noun-link.2d716d779f7c7c3a3b9b1c9e68ae7c27.svg";
export { ForwardRef as ReactComponent };